import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { MessageHubService } from "src/app/shared/services/message-hub.service";
import * as MessageHubActions from '../../../../state/actions/message-hub.actions';
import * as DataImportLogActions from "./actions/data-import-logs.actions";

@Injectable()
export class DataImportLogEffects {
    constructor(private actions$: Actions, private messageHubService: MessageHubService) { }

    subscribeToDataImportLogs$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(DataImportLogActions.subscribeToProvisionLogData),
                switchMap(action => {
                    this.messageHubService.subscribeToDataImportGroup({
                        TenantId: action.tenantId,
                        UserId: action.userId
                    });
                    return of(MessageHubActions.joinDataImportGroupComplete())
                })
            )
    })
}